import * as React from 'react';

import {IntegrationWidget} from 'shells/integration-widget/integration-widget';

import type {ExternalServiceType} from 'nutshell-graphql-types';

import {getServiceNoun, getServiceTypeIcon} from '../helpers';

type Props = {
    isConnected: boolean;
    onConnectClick: () => void;
    serviceType: ExternalServiceType;
};

export function ConnectButton(props: Props) {
    return (
        <IntegrationWidget
            status='initial'
            account={null}
            initialText={`Connect to ${getServiceNoun(props.serviceType)}`}
            logo={getServiceTypeIcon(props.serviceType)}
            onConnectClick={props.onConnectClick}
            disabled={props.isConnected}
            onDisconnectClick={() => {}}
        />
    );
}
